﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_commons_1 = require("@its-suite/app-commons");
const form_controls_1 = require("@its-suite/form-controls");
const React = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const classnames_1 = require("classnames");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const components_1 = require("../../components");
const Utils_1 = require("../../Utils");
const styles = require("./UserProfileForm.scss");
exports.profileFormPrefixId = Utils_1.PrefixId.UserProfileForm;
exports.editableGroupPrefixId = `${exports.profileFormPrefixId}-eg`;
class UserProfileFormInternal extends React.Component {
    constructor(props) {
        super(props);
        this.userClient = operational_context_client_1.OperationalContextClientFactory.getUserClient();
        this.componentDidMount = () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.fetchProfileData();
            }
            catch (ex) {
                this.props.showErrorSnackbar(ex.response);
            }
            finally {
                this.setState({ loading: false });
            }
        });
        this.renderForm = () => {
            console.log('UserProfileForm render');
            return (React.createElement(form_controls_1.ValidatorForm, { className: classnames_1.default(styles.formBlock, styles.editProfileForm), onSubmit: this.saveData },
                this.renderGenericDataGroup(),
                this.renderPasswordGroup(),
                this.renderPinGroup(),
                React.createElement(form_controls_1.FormSubmit, { cancelText: this.props.translate('Cancel'), cancelAction: this.onCancel, saveText: this.props.translate('Save'), saveButtonDisabled: this.state.saving, showSave: this.state.isBeingGenericDataEdited || this.state.isBeingPasswordEdited || this.state.isBeingPinEdited, id: exports.profileFormPrefixId })));
        };
        this.renderGenericDataGroup = () => {
            return (React.createElement(form_controls_1.EditableGroup, { prefixId: exports.editableGroupPrefixId, groupId: 'generic-data', groupName: this.props.translate('GenericData'), onClickEdit: this.toggleGenericData, className: [styles.noMarginX, styles.w100] },
                React.createElement("div", { className: classnames_1.default(styles.gridForm, styles.fillLastRow) },
                    React.createElement("div", { className: styles.imageArea },
                        React.createElement(form_controls_1.ProfileImage, { size: styles.profileImgSize })),
                    React.createElement("div", null,
                        React.createElement(form_controls_1.TextField, { id: form_controls_1.IdentifierHelpers.createId(exports.profileFormPrefixId, form_controls_1.IdentifierHelpers.IdForElement.TextField, ['username']), name: form_controls_1.StringHelpers.nameof('userName'), label: this.props.translate('Username'), className: styles.formControl, value: this.state.values.userName, autoComplete: 'off', disabled: true })),
                    React.createElement("div", null,
                        React.createElement(form_controls_1.TextField, { id: form_controls_1.IdentifierHelpers.createId(exports.profileFormPrefixId, form_controls_1.IdentifierHelpers.IdForElement.TextField, ['fullName']), name: form_controls_1.StringHelpers.nameof('fullName'), label: this.props.translate('FullName'), className: styles.formControl, value: this.state.values.fullName, autoComplete: 'off', validators: [this.requiredValidator], disabled: !this.state.isBeingGenericDataEdited, onChange: this.handleInputChange })),
                    React.createElement("div", { className: styles.span },
                        React.createElement(form_controls_1.TextField, { id: form_controls_1.IdentifierHelpers.createId(exports.profileFormPrefixId, form_controls_1.IdentifierHelpers.IdForElement.TextField, ['emailAddress']), name: form_controls_1.StringHelpers.nameof('email'), label: this.props.translate('Email'), className: classnames_1.default(styles.formControl, styles.w100), value: this.state.values.email, autoComplete: 'off', validators: [this.emailValidator], disabled: !this.state.isBeingGenericDataEdited, onChange: this.handleInputChange })))));
        };
        this.renderPasswordGroup = () => {
            return (React.createElement(form_controls_1.EditableGroup, { prefixId: exports.editableGroupPrefixId, groupId: 'passwd', groupName: this.props.translate('Password'), onClickEdit: this.togglePassword, className: [styles.noMarginX, styles.w100] },
                React.createElement("div", { className: classnames_1.default(styles.gridForm, styles.fillFirstRow) },
                    React.createElement(components_1.UpdatePasswordFields, { isEnabled: this.state.isBeingPasswordEdited, passwordValue: this.state.values.password, currentPasswordValue: this.state.values.currentPassword, passwordConfirmationValue: this.state.values.confirmationPassword, username: this.props.username, texts: Utils_1.PasswordLocalizedTextUtil.getUpdatePasswordFieldsTexts(this.props.translate), onChange: this.handleInputChange, inputsContainerClassName: [], inputsClassName: [styles.w100, styles.formControl] }))));
        };
        this.renderPinGroup = () => {
            return (React.createElement(form_controls_1.EditableGroup, { prefixId: exports.editableGroupPrefixId, groupId: 'pin', groupName: this.props.translate('PIN'), onClickEdit: this.togglePin, className: [styles.noMarginX, styles.w100] },
                React.createElement("div", { className: styles.gridForm },
                    React.createElement(components_1.PinFields, { disabled: !this.state.isBeingPinEdited, onChange: this.handleInputChange, pinValue: this.state.values.pin, pinConfirmationValue: this.state.values.pinConfirmation, texts: Utils_1.PinLocalizedTextUtils.getDefaultPinTexts(this.props.translate), className: styles.formControl, prefixId: exports.profileFormPrefixId }))));
        };
        this.fetchProfileData = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield this.userClient.get(this.props.username);
            this.setState({
                originalUserData: data,
                values: Object.assign(Object.assign({}, data), { currentPassword: '', password: '', confirmationPassword: '', pin: '', pinConfirmation: '' })
            });
        });
        this.toggleGenericData = () => {
            this.toggleGroup('isBeingGenericDataEdited');
        };
        this.togglePassword = () => {
            this.toggleGroup('isBeingPasswordEdited');
        };
        this.togglePin = () => {
            this.toggleGroup('isBeingPinEdited');
        };
        this.toggleGroup = (groupStateKey) => {
            this.setState((prevState) => (Object.assign(Object.assign(Object.assign({}, prevState), { [groupStateKey]: !prevState[groupStateKey] }), this.getDisabledGroups(groupStateKey))));
        };
        this.getDisabledGroups = (keyToEnable) => {
            const groupsKeys = ['isBeingPasswordEdited', 'isBeingGenericDataEdited', 'isBeingPinEdited'];
            const groupKeysToDisable = groupsKeys.filter(key => key !== keyToEnable);
            return groupKeysToDisable.reduce((acc, current) => (Object.assign(Object.assign({}, acc), { [current]: false })), {});
        };
        this.handleInputChange = (evt) => {
            this.updateFormValue(evt.target.name, evt.target.value);
        };
        this.updateFormValue = (propertyName, value) => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { values: Object.assign(Object.assign({}, prevState.values), { [propertyName]: value }) })));
        };
        this.saveData = () => __awaiter(this, void 0, void 0, function* () {
            this.setState({ saving: true });
            let promise;
            if (this.state.isBeingGenericDataEdited) {
                promise = this.userClient.update(this.props.username, this.mapFormToUser());
            }
            else if (this.state.isBeingPasswordEdited) {
                promise = this.userClient.updatePassword(this.props.username, this.generateUpdatePasswordRequest());
            }
            else {
                promise = this.userClient.resetPin(this.props.username, { credential: this.state.values.pin });
            }
            promise
                .then(() => this.props.showInfoSnackbar(this.props.translate('Operation_Succeeded')))
                .catch((ex) => {
                this.props.showErrorSnackbar(ex.response);
            })
                .finally(() => { this.setState({ saving: false }); });
        });
        this.mapFormToUser = () => (Object.assign(Object.assign({}, this.state.originalUserData), { fullName: this.state.values.fullName, email: this.state.values.email, userName: this.props.username }));
        this.generateUpdatePasswordRequest = () => ({
            currentCredential: this.state.values.currentPassword,
            newCredential: this.state.values.password
        });
        this.onCancel = () => {
            this.props.onClose();
        };
        this.state = {
            isBeingGenericDataEdited: false,
            isBeingPasswordEdited: false,
            isBeingPinEdited: false,
            loading: true,
            originalUserData: {
                fullName: '',
                isAutogenerated: false
            },
            saving: false,
            values: {
                fullName: '',
                isAutogenerated: false,
                currentPassword: '',
                password: '',
                confirmationPassword: '',
                pin: '',
                pinConfirmation: ''
            }
        };
        this.requiredValidator = new form_controls_1.Validator({ validatorType: form_controls_1.ValidatorTypes.Required, message: this.props.translate('ErrorRequiredField') });
        this.emailValidator = new form_controls_1.Validator({ validatorType: form_controls_1.ValidatorTypes.Email, message: this.props.translate('ErrorEmail') });
    }
    render() {
        return (React.createElement("div", { className: styles.formContainer }, this.state.loading ? React.createElement(form_controls_1.CircularProgress, null) : this.renderForm()));
    }
}
exports.UserProfileFormInternal = UserProfileFormInternal;
function mapStateToProps(state) {
    return {
        username: state.session.username,
        translate: state.translate
    };
}
function mapDispatchToProps(dispatch) {
    return redux_1.bindActionCreators({
        showErrorSnackbar: app_commons_1.MessagesActions.actionCreators.triggerShowExceptionMessage,
        showInfoSnackbar: app_commons_1.MessagesActions.actionCreators.triggerShowInfoMessage
    }, dispatch);
}
exports.UserProfileForm = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UserProfileFormInternal);
//# sourceMappingURL=UserProfileForm.js.map